import {Container, StatsWrap, SubTitle, Title, TitleWrap, Wrap, Stat} from "./styled";
import {AnimatedNumber} from "./AnimatedNumber/AnimatedNumber";
import {ParallaxBackground} from "../../CummonComponents/ParallaxBackground/ParallaxBackground";
import {useImageUrl} from "../../../queries";
import {Text} from "../../ProductPageComponents/WhatIsData/styled";

export const Hero = ({data}) => {
    const headerTitle = data?.hero_title || '';
    const headerDescription = data?.header_description || '';
    const headerRightList = data?.header_right_list || [];
    const headerImageUrl = useImageUrl(data?.header_background_image);

    return (
        <Container>
            <ParallaxBackground
                imageUrl={headerImageUrl || ""}
                speedFactor={-0.2}
                height={'150%'}
            />

            <Wrap>
                <TitleWrap>
                    <Title dangerouslySetInnerHTML={{__html: headerTitle.replace(/\n/g, "<br/>")}}/>
                    <SubTitle>{headerDescription}</SubTitle>
                </TitleWrap>
                <StatsWrap>
                    {headerRightList.map((item, index) => (
                        <Stat key={index}>
                            {item.title} <br/>
                            [<AnimatedNumber value={parseInt(item?.value?.replace(/,/g, '')) || 0}/>]
                        </Stat>
                    ))}
                </StatsWrap>
            </Wrap>
        </Container>
    )
}
